export enum IngressPoint {
    ASH ="ASH",
    EMAIL = "EMAIL",
    SMS = "SMS",
    MOBILE_APP = 'MOBILE_APP'
}

export default interface PreHireWelcomeResponse {
    ingress: IngressPoint,
    login: string,
    preferredName: string
}
